import { useStudioStore } from '@/components/bookclass/stores/studioStore'
import { sendContainerRequest } from '@/container'
import { useQuery } from '@tanstack/vue-query'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import {
    IntegrationStatus,
    PaymentGateway,
    type StudioPaymentIntegration,
} from '../types'

async function getStudioPaymentIntegration(studioId: string) {
    if (!studioId) {
        return null
    }
    const result = await sendContainerRequest('getStudioPaymentIntegration', {
        studioId,
    })

    const finalResult = result.data
    if (finalResult.success) {
        return finalResult.data
    }

    throw new Error(finalResult.error)
}

export function useStudioPaymentIntegration() {
    const studioStore = useStudioStore()
    const { studio } = storeToRefs(studioStore)

    const queryKey = computed(() => [
        'studioPaymentIntegration',
        studio.value?.id,
    ])
    const paymentIntegrationQuery = useQuery({
        queryKey: queryKey,
        queryFn: ({ queryKey }) => getStudioPaymentIntegration(queryKey[1]),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
    })

    const isStripeIntegrated = computed(() => {
        const result = paymentIntegrationQuery.data
            .value as StudioPaymentIntegration

        return (
            result?.paymentGateway === PaymentGateway.STRIPE &&
            result?.integrationStatus === IntegrationStatus.ACTIVE
        )
    })

    return {
        ...paymentIntegrationQuery,
        isStripeIntegrated,
    }
}
